/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IDoctor } from 'app/shared/model/doctor.model';
import { IHospital } from 'app/shared/model/hospital.model';
import { DayOfWeek } from 'app/shared/model/enumerations/day-of-week.model';
import { RecurrenceType } from 'app/shared/model/enumerations/recurrence-type.model';
import { ConsultType } from 'app/shared/model/enumerations/consult-type.model';

export interface IDoctorAvailability {
  id?: string;
  dayOfWeek?: keyof typeof DayOfWeek | null;
  recurrenceType?: keyof typeof RecurrenceType | null;
  timestampentry?: number;
  microSec?: number;
  lastupdated?: number;
  active?: boolean;
  cursor?: number;
  startTime?: number | null;
  endTime?: number | null;
  startDate?: number | null;
  endDate?: number | null;
  draft?: boolean | null;
  suspended?: boolean | null;
  enforceSchedule?: boolean | null;
  consultType?: keyof typeof ConsultType | null;
  NoOfAppts?: number | null;
  NoOfSlotsForSchedule?: number | null;
  doctorId?: IDoctor;
  hospital?: IHospital;
}

export const defaultValue: Readonly<IDoctorAvailability> = {
  active: false,
  draft: false,
  suspended: false,
  enforceSchedule: false,
};
